import { JackpotTiers } from "ags/names";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";

export class HoldAndSpinScatterResult extends BonusResult {
    public resultType = "HoldAndSpinScatterResult";
    public reel: number;
    public jackpotTier: string;
    public winAmount: number;
}
